//const ServerAPI = process.env.SERVER_API;

import { createContext, useState, useMemo, useEffect } from 'react';
//import { TSUsers } from 'types/Users';
import { useNavigate, useLocation } from 'react-router-dom';
import { requestAPI } from '../utils/api';
//import { UIContext } from './UIContext';

		

/* LanguagePack::Start
    ContextAuth_LoginFailure:ko: "회원 정보가 존재하지 않습니다.",
    ContextAuth_LoginFailure:en: "회원 정보가 존재하지 않습니다.",
    ContextAuth_PasswordNotMatch:ko: "비밀번호가 일치하지 않아요",
    ContextAuth_PasswordNotMatch:en: "비밀번호가 일치하지 않아요",
    ContextAuth_LogoutFailed:ko: "로그아웃에 실패했어요",
    ContextAuth_LogoutFailed:en: "로그아웃에 실패했어요",
    ContextAuth_LoginSuccess:en: "You have successfully logged in.",
    ContextAuth_RegistrationFailed:en: "Member registration failed.",
    ContextAuth_RegistrationFailed:ko: "회원 가입에 실패 하였습니다.",
    ContextAuth_RegistrationSuccess:en: "You have successfully registered as a member.",
    ContextAuth_RegistrationSuccess:ko: "회원 가입에 성공 하였습니다.",
LanguagePack::End */


type NotificationMesssageType = {
    type: string;
    contents: string;
}

type MemberData = {
    tokenInfo: any;
    userInfo: any;
    agencyList: any;
    isLoginProcess: boolean;
}

interface ContextProps {
	// 내 정보
	readonly initData: any; readonly setInitData: (initData: any) => void;
	//const [ initData, setInitData ] = useState <any> ([]);

	readonly get: (db: any) => void;
	readonly set: (db: any, value: any) => void;
	readonly getDB: ({db, params}: any) => void;
	readonly wrapAPI : (method: string, path: string, data: any) => void;
	readonly allowAccessGroup: (arr: any) => void;

	readonly productOrderInfo: any; readonly setProductOrderInfo: (agencyViewDB: any) => void;
}

const GlobalDataContext = createContext<ContextProps> ({
	initData: [], setInitData: () => null,
	
	get: (db: any) => {},
	set: (db: any, value: any) => {},
	getDB: ({db, params}: any) => {},
	wrapAPI: (method: string, path: string, data: any) => {},
	allowAccessGroup: (arr: any) => {},

	productOrderInfo: {}, setProductOrderInfo: () => null,
	
	/* eslint-enable @typescript-eslint/no-empty-function */
});



interface Props {
	//readonly lng: any;
	//readonly memberInfo: MemberData;
	//readonly initInfo: any;
	readonly _initData: any;
    readonly children: JSX.Element | JSX.Element[];
}

const GlobalDataProvider = ({
	//lng, 
	//memberInfo, 
	_initData,
	children
}: Props): JSX.Element => {

// const {
// 	modal,
// 	notify
// } = useContext(UIContext);  

console.log('[GlobalDataProvider] Init ')
// const navigate = useNavigate ();
const location = useLocation();


// 나의 정보
const [ initData, setInitData ] = useState <any> (_initData);

const [ productOrderInfo, setProductOrderInfo ] = useState <any> ({});

//const [ sidebarOpen, setSidebarOpen ] = useState (false);

// if (allowAccessGroup() !== 'PASS') {
	
// 	window.location.href = "/notaccessallowed";
// 	return (<></>);
// }

//console.log('initData ', initData)

const values: any = {
	initData, setInitData,
	get, 
	set,
	getDB,
	allowAccessGroup,
	wrapAPI,
	productOrderInfo, setProductOrderInfo,
	//sidebarOpen, setSidebarOpen
};

function userDBUpdate () {

	// let url = location.pathname;
	
	// if (userDB.tokenInfo === "Guest") {	
	// 	if (url === '/signin') {
	// 		// 손님의 경우 로그인 페이지 접근
			
	// 	} else {
	// 		// 손님의 경우 다른 페이지 접근 시 로그인 페이지로 강제 이동
			
	// 		switch (url) {
	// 			case '/logout': navigate('/logout'); break;
	// 			default: navigate('/signin'); break;
	// 		}
	// 	}
	// } else {
		
	// 	if (url === '/signin') {
	// 		// 로그인된 유저는 로그인 페이지 접근 금지하며 기본 페이지로 강제 이동
	// 		window.location.href = basicHome();
	// 	} else {
	// 		if (url === '/') {
	// 			window.location.href = basicHome();
	// 			//navigate('/signin');
	// 		} else {
	// 			navigate(url);
	// 		}
			
	// 	}
	// }
}

function allowAccessGroup () {
	
	const group: any = {
		'/': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
		'/401': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
		'/404': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
		'/users': ['SUPER', 'HQ'],
		'/home': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
		'/agencies': ['SUPER', 'HQ'],
		'/agencyusers': ['SUPER', 'HQ', 'AGENCY'],
		'/classroom': ['SUPER', 'HQ', 'AGENCY'],
		'/certificates': ['SUPER', 'HQ', 'AGENCY'],
		'/courses': ['SUPER', 'HQ'],
		'/sms': ['SUPER', 'HQ'],
		'/myclassrooms': ['SUPER', 'HQ', 'AGENCY', 'CAREGIVER'],
		'/surveybank': ['SUPER', 'HQ'],
		'/survey': ['SUPER', 'HQ'],
		'/testbank': ['SUPER', 'HQ'],
		'/lessonbank': ['SUPER', 'HQ'],
		'/userhome': ['CAREGIVER'],
		
	};

	// let url = location.pathname;
	// let sw = null;
	// if (group[url] === undefined) url ='/404';
	
	
	// if (userDB.tokenInfo === 'Guest') {
	// 	return 'PASS';
	// } else {
	// 	sw = group[url].find((item: string) => item === userDB.userInfo.role);
	// 	if (sw === undefined) return 'FAIL';
	// 	return 'PASS';
	// }
};

function get(db: any) { return new Promise( async (resolve, reject) => {

	//console.log('get ', db);

	let store: any = values[db];
	
	//console.log('get store', store);

	resolve(store);
});}

function set (db: any, value: any) { return new Promise( async (resolve, reject) => {

	let setStore: any = values[`set${db.charAt(0).toUpperCase() + db.slice(1)}`];
	
	setStore(value);

	resolve(value);
});}


function getDB ({db, params, update}: any) { return new Promise( async (resolve, reject) => {

	let store: any = values[db];
	let setStore: any = values[`set${db.charAt(0).toUpperCase() + db.slice(1)}`];
	let url: string = "";
	let res = null;
	let result: any = null;

	switch (db) {
		case 'userListDB': 				url = `v1/users`; 										break;
	}

	

	result = await execute ();			
	
	resolve (result);

	async function execute () { return new Promise( async (resolve, reject) => {
		
		let result: any = null;
		
		// store에 키가 존재하는지 체크	
		if (Object.keys(store).length === 0) {
			// 새로운 데이터 가져오기
			result = newUpdate(setStore, url, params);
		} else {
			// 강제 업데이트 체크
			if (update === undefined || update === false) {
				
				// 파라미터 체크
				if (params.id === undefined) {
					// 파라미터가 없으면 메모리에서 가져오기
					result = store;
				} else {
					
					// 파라미터가 존재하는 경우 요청 id를 체크
					if (params.id === store._id) {
						
						// 요청 id가 같은 경우 메모리에서 가져오기
						result = store;
					} else {
						
						// 요청 id가 같지 않은 경우 새롭게 업데이트
						result = newUpdate(setStore, url, params);
					}
				}
				
			} else {
				// 강제 업데이트가 아닌경우 메모리에서 가져오기
				result =  newUpdate(setStore, url, params);
			}
		}

		resolve (result);
	});}

	async function newUpdate (setData: any, path: string, params: any) { return new Promise( async (resolve, reject) => {
		
		const res: any = await wrapAPI('GET', path, params);
				
		setData (res.data);
		resolve (res.data);
	});}
	
});}

function wrapAPI (method: string, path: string, data: any) { return new Promise( async (resolve, reject) => {
	try{

		let modalMessage = null;
		
		console.log('wrapAPI ', method);

		const returnData: any = await requestAPI(method, path, data);
		
		console.log('wrapAPI end');
		
		if (returnData.code === 1000) {
			return resolve(returnData);	
		}

		switch (returnData.code) {
			case 400:
				modalMessage = {
					title: "권한없음",
					contents: "요청하신 API에 대한 권한이 없어요, 계속 문제가 발생할 경우 관리자에게 문의하세요 (Code: 400)",
				}
				window.location.href = '/logout';
				// API 권한이 일치하지 않을때
				break;
	
			case 500:
				// Token 또는 DB Session이 없는 경우
				window.location.href = '/logout';
				break;
			default:
				//알수 없는 오류
				break;
			
		}

		if (modalMessage !== null) {
			// modal({
			// 	title: modalMessage.title, 
			// 	contents: modalMessage.contents,
			// 	buttons: [
			// 	{
			// 		label: 'Confirm',
			// 		color: 'viseCare',
			// 		fn: async () => {
				
			// 		}
			// 	}]
			// });	
		}

		console.log('wrapAPI resolve');
		resolve(returnData);

	} catch (err) {
		console.log('wrapAPI reject');
		// modal({
		// 	title: "서버 오류가 발생했어요", 
		// 	contents: "재접속을 시도해요",
		// 	buttons: [{
		// 		label: 'cancel',
		// 		color: 'gray',
		// 		fn: () => null
		// 	},
		// 	{
		// 		label: '재접속',
		// 		color: 'viseCare',
		// 		fn: async () => {
		// 			window.location.href = '/signin';
		// 		}
		// 	}]
		// });	
	}
});}



// useMemo (() => {
	
// }, []);

//useEffect ( () => {userDBUpdate()}, [userDB]);


// function basicHome () {
// 	let url = '/home';

// 	switch (userDB.userInfo.role) {
// 		case 'SUPER':  url = '/users';   break;
// 		case 'HQ':  url = '/users';   break;
// 		case 'AGENCY':  url = '/home';   break;
// 		case 'CAREGIVER': url = '/userhome'; break;
// 	}

// 	return url;
// }

//const newValues = {...values, getDB, allowAccessGroup}

	return (		
		<GlobalDataContext.Provider value={values}>
			{children}
		</GlobalDataContext.Provider>
	);
};

export {GlobalDataContext, GlobalDataProvider};